import { render, staticRenderFns } from "./people-list.vue?vue&type=template&id=35fcaf2e&scoped=true&lang=html&"
import script from "./people-list.vue?vue&type=script&lang=js&"
export * from "./people-list.vue?vue&type=script&lang=js&"
import style0 from "./people-list.vue?vue&type=style&index=0&id=35fcaf2e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fcaf2e",
  null
  
)

export default component.exports